var _module_exports = "<div>\n  <h2>{{ $ctrl._identify }}</h2>\n</div>\n";;
var path = '/workspace/src/app/components/workroom/project-team/project-team.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;